// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s6E04O[data-testid\$='-content'] {
  width: 960px;
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 48px);
}

.s6E04O ._7UB2eX {
  min-height: 0;
  padding: var(--spacing-2);
}

.i5c2LK {
  display: block;
  width: 100%;
  height: min(70vh, 720px);
  border: 1px solid var(--stroke-neutral-subtle);
  background: var(--surface-neutral-white);
}

.EBaCmW {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--spacing-2);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/BenefitMigrationPage/components/MigrationTermsModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,8CAA8C;EAC9C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB","sourcesContent":[".modal[data-testid$='-content'] {\n  width: 960px;\n  max-width: calc(100vw - 32px);\n  max-height: calc(100vh - 48px);\n}\n\n.modal .body {\n  min-height: 0;\n  padding: var(--spacing-2);\n}\n\n.document {\n  display: block;\n  width: 100%;\n  height: min(70vh, 720px);\n  border: 1px solid var(--stroke-neutral-subtle);\n  background: var(--surface-neutral-white);\n}\n\n.feedback {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: var(--spacing-2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `s6E04O`,
	"body": `_7UB2eX`,
	"document": `i5c2LK`,
	"feedback": `EBaCmW`
};
module.exports = ___CSS_LOADER_EXPORT___;
